import React, { Component } from 'react';
import {glyphs} from '../../../../settings.json';
import {scaleLinear } from 'd3-scale';
import Snap from 'snapsvg-cjs';
import './Arrow.css';

const width = 32;
const height = 80;

class Letter extends Component{

  constructor(props) {
    super(props);
    this.svg = React.createRef();
  }

  componentDidUpdate(prevProps){
    prevProps.hover !== this.props.hover && this.toggleState();
  }


  componentDidMount(){
    this.snap = Snap(this.svg.current);
    this.snap.attr(glyphs.snapAttr)
    this.path = this.snap.path(this.pathOpen());
  }

  toggleState(){
    this.props.hover ?
    this.path.animate({ d: this.pathHover()},100) :
    this.path.animate({ d: this.pathOpen()},100) ;
  }

  calcPos(percent, size){
    let margin = 4;
    let map = scaleLinear()
      .domain([0, size])
      .range([margin, size - margin]);
    return map(size * percent);
  }

  pathOpen(){
    let pos = this.calcPos;
    let path = "";
    path = path + `M${ pos(1.0, width) } ${ pos(0.0, height) } `;
    path = path + `L${ pos(0.0, width) } ${ pos(0.5, height) } `;
    path = path + `L${ pos(1.0, width) } ${ pos(1.0, height) } `;
    return path;
  }

  pathHover(){
    let pos = this.calcPos;
    let path = "";
    path = path + `M${ pos(0.5, width) } ${ pos(0.0, height) } `;
    path = path + `L${ pos(0.0, width) } ${ pos(0.5, height) } `;
    path = path + `L${ pos(0.5, width) } ${ pos(1.0, height) } `;
    return path;
  }

  render(){
    return (
      <div ref={this.container} className="Arrow-container">
        <svg ref={this.svg} className="Arrow-svg"  />
      </div>
    )
  }
}

export default Letter;


// WEBPACK FOOTER //
// ./src/components/galleryItems/Project/Arrow/ArrowLeft.js